/* JS Categories: robust initializer for live + AJAX-loaded sections */
(function () {
  // ---- Helpers ----------------------------------------------------
  function setLoaded(img) {
    img.dataset.loaded = 'true';
    var wrap = img.closest('.category-image-wrapper');
    if (wrap) wrap.classList.add('is-loaded');
  }

  function setupImageLoading(sectionEl) {
    var lazyImgs = sectionEl.querySelectorAll('.category-image[loading="lazy"]');
    var priorityImgs = sectionEl.querySelectorAll('.category-image[fetchpriority="high"]');

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var img = entry.target;
          if (img.complete) setLoaded(img);
          else img.addEventListener('load', function () { setLoaded(this); }, { once: true });
          io.unobserve(img);
        });
      }, { rootMargin: '50px' });

      lazyImgs.forEach(function (img) { io.observe(img); });
    } else {
      sectionEl.querySelectorAll('.category-image').forEach(function (img) {
        if (img.complete) setLoaded(img);
        else img.addEventListener('load', function(){ setLoaded(this); }, { once: true });
      });
    }

    priorityImgs.forEach(function (img) {
      if (img.complete) setLoaded(img);
      else img.addEventListener('load', function(){ setLoaded(this); }, { once: true });
    });
  }

  function applySmartResizing(sectionEl) {
    var cards = sectionEl.querySelectorAll('.category-card');
    if (!cards.length) return;

    var hasCustomHeights = false;
    var contentVariability = 0;

    cards.forEach(function (card) {
      var imageWrapper = card.querySelector('.category-image-wrapper');
      var styleAttr = imageWrapper && imageWrapper.getAttribute('style') || '';
      if (styleAttr.indexOf('--custom-height') !== -1) hasCustomHeights = true;

      var parts = [
        card.querySelector('.category-features'),
        card.querySelector('.category-description'),
        card.querySelector('.category-meta'),
        card.querySelector('.category-cta')
      ].filter(function (el) { return el && el.offsetParent !== null; });

      contentVariability += parts.length;
    });

    var avg = contentVariability / cards.length;
    if (hasCustomHeights) {
      sectionEl.classList.add('mixed-heights');
      // Use the computed grid gap (or a safe default)
      var gap = getComputedStyle(sectionEl).getPropertyValue('--grid-gap-enhanced') ||
                getComputedStyle(sectionEl).getPropertyValue('--grid-gap') ||
                '20px';
      sectionEl.style.setProperty('--grid-gap-enhanced', gap.toString().trim());
    }
    if (avg <= 2) sectionEl.classList.add('minimal-content');
  }

  function managePopoutZIndex(sectionEl) {
    sectionEl.querySelectorAll('.popout-card').forEach(function (card, index) {
      card.style.setProperty('--card-index', index);
      if (card.dataset.zbound) return;
      card.dataset.zbound = '1';
      card.addEventListener('mouseenter', function(){ this.style.zIndex = '100'; });
      card.addEventListener('mouseleave', function(){ this.style.zIndex = ''; });
    });
  }

  function setupDelegatedToggle(sectionEl) {
    if (sectionEl.dataset.toggleBound) return;
    sectionEl.dataset.toggleBound = '1';

    // Works even if the button gets re-rendered
    sectionEl.addEventListener('click', function (e) {
      var btn = e.target.closest('.categories-toggle');
      if (!btn || !sectionEl.contains(btn)) return;

      var expanded = sectionEl.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');

      var label = btn.querySelector('.label');
      if (label) label.textContent = expanded ? 'Show fewer categories' : 'View all categories';

      if (typeof gtag !== 'undefined') {
        gtag('event', 'categories_toggle', { expanded: expanded, event_category: 'product_navigation' });
      }
    });
  }

  function setupDelegatedClickTracking(sectionEl) {
    if (sectionEl.dataset.ctBound) return;
    sectionEl.dataset.ctBound = '1';

    sectionEl.addEventListener('click', function (e) {
      var link = e.target.closest('.category-link');
      if (!link || !sectionEl.contains(link)) return;

      var card = link.closest('.category-card');
      var wrap = card && card.querySelector('.category-image-wrapper');
      var hasCustomHeight = !!(wrap && ((wrap.getAttribute('style') || '').indexOf('--custom-height') !== -1));
      var titleEl = link.querySelector('.category-title');
      var categoryName = titleEl ? titleEl.textContent : '';
      var features = Array.prototype.slice.call(link.querySelectorAll('.feature-tag')).map(function (t) { return t.textContent; });

      if (typeof gtag !== 'undefined') {
        gtag('event', 'category_selection', {
          category_name: categoryName,
          features: features.join(', '),
          has_custom_height: hasCustomHeight,
          event_category: 'product_navigation'
        });
      }
    });
  }

  function initSection(sectionEl) {
    if (!sectionEl || sectionEl.dataset.jsBound) return;
    sectionEl.dataset.jsBound = '1';
    setupImageLoading(sectionEl);
    applySmartResizing(sectionEl);
    managePopoutZIndex(sectionEl);
    setupDelegatedToggle(sectionEl);
    setupDelegatedClickTracking(sectionEl);

    window.addEventListener('resize', function () {
      applySmartResizing(sectionEl);
      managePopoutZIndex(sectionEl);
    }, { passive: true });
  }

  function scanAndInit() {
    document.querySelectorAll('[id^="janisource-categories-"]').forEach(initSection);
  }

  // Initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanAndInit);
  } else {
    scanAndInit();
  }

  // Shopify section loads (Theme Editor + some themes that AJAX sections)
  document.addEventListener('shopify:section:load', function (evt) {
    if (!evt.target) return;
    evt.target.querySelectorAll('[id^="janisource-categories-"]').forEach(initSection);
  });

  // Fallback: observe for injected HTML (some loaders replace innerHTML after DOMContentLoaded)
  try {
    var mo = new MutationObserver(function () { scanAndInit(); });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) { /* ignore */ }
})();

